module.exports = __webpack_public_path__ + "img/PY.dbc26026.png";